import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    standalone: false,
    selector: '[appHost]',
})
export class HostDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
